import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
import { useVendorIndexPolling } from "../Context/vendorIndexPollingContext";

const PHASE_LABELS = {
  INDEXING: "Reindicizzazione vendor...",
  DONE: "Reindex vendor completato",
  FAILED: "Errore reindex vendor",
};

const VendorProgressCard = ({ vendor }) => {
  const isError = vendor.phase === "FAILED";
  const percentage = Math.min(100, Math.max(0, vendor.percentage ?? 0));

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        backgroundColor: "white",
        borderRadius: "20px",
        boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",
        padding: "10px 16px 10px 10px",
      }}
    >
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          variant="determinate"
          value={percentage}
          size={48}
          thickness={4}
          sx={{ color: isError ? "#e00036" : "#0b3d87" }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Rubik",
              fontSize: "11px",
              fontWeight: "bold",
              color: "#0b3d87",
            }}
          >
            {percentage}%
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          sx={{
            fontFamily: "Rubik",
            fontSize: "12px",
            fontWeight: "bold",
            color: "#0b3d87",
          }}
        >
          {PHASE_LABELS[vendor.phase] || PHASE_LABELS.INDEXING}
        </Typography>
        <Typography sx={{ fontFamily: "Rubik", fontSize: "12px", color: "#0b3d87" }}>
          Vendor {vendor.vendorId} — {vendor.processed} / {vendor.total} documenti
        </Typography>
      </Box>
    </Box>
  );
};

VendorProgressCard.propTypes = {
  vendor: PropTypes.shape({
    vendorId: PropTypes.number,
    phase: PropTypes.string,
    percentage: PropTypes.number,
    processed: PropTypes.number,
    total: PropTypes.number,
    finishedAt: PropTypes.string,
  }).isRequired,
};

const VendorIndexProgress = () => {
  const { vendors } = useVendorIndexPolling();

  if (vendors.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 1400,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
      }}
    >
      {vendors.map((vendor) => (
        <VendorProgressCard key={vendor.vendorId} vendor={vendor} />
      ))}
    </Box>
  );
};

export default VendorIndexProgress;
